<script>
  import reveal from '../lib/actions/reveal.js';
  import Button from '../lib/ui/Button.svelte';
  import parallax from '../lib/actions/parallax.js';
</script>

<section class="section" aria-label="Intro Video" style="padding-top: 48px;">
  <div class="container" style="position:relative">
    <div class="beams" aria-hidden="true" use:parallax={{speed:0.08}}>
      <div class="beam" style="left: 5%"></div>
      <div class="beam"></div>
      <div class="beam"></div>
      <div class="beam"></div>
    </div>

    <div class="grid" style="grid-template-columns: 1.1fr .9fr; align-items: center; gap: 36px;">
      <div use:reveal>
        <div class="eyebrow">Intro Video</div>
        <h1 class="section-header glow" style="font-size: clamp(36px, 6vw, 64px); margin: 10px 0 14px;">
          From NFTs to NFAs —
          <span class="text-gradient">filled with Light</span>
        </h1>
        <p style="color: var(--muted); font-size: 18px; line-height: 1.65; max-width: 60ch;">
          In a cinematic ascension, dormant NFTs awaken under Arcturian Light. Their eyes open, code flows, and they evolve into intelligent, autonomous Non‑Fungible Agents.
        </p>
        <div style="display:flex; gap: 12px; margin-top: 22px;">
          <Button href="#launch" variant="primary">Get Notified</Button>
          <Button href="#what" variant="ghost">Learn more</Button>
        </div>
      </div>

      <div use:reveal={{delay:120}}>
        <div class="glass" style="position:relative; overflow:hidden; aspect-ratio: 16 / 9;" use:parallax={{speed:0.12}}>
          <!-- Replace media/intro.mp4 with your cinematic video -->
          <video src="/media/intro.mp4" autoplay muted playsinline loop style="width: 100%; height: 100%; object-fit: cover; background: #000;">
          </video>
          <div style="position:absolute; inset:0; background: radial-gradient(120% 80% at 50% 10%, rgba(0,255,198,.06), rgba(33,243,255,.04), transparent 60%);"></div>
        </div>
        <small style="display:block; color: var(--muted); margin-top: 8px;">Placeholder video. Replace at <code>/public/media/intro.mp4</code>.</small>
      </div>
    </div>
  </div>
</section>
